module.exports = __webpack_public_path__ + "static/thisisme-8e78ef8ed4cf19262f00d8e56a570114.jpg";